import script from "./MFAChoice.vue?vue&type=script&setup=true&lang=js"
export * from "./MFAChoice.vue?vue&type=script&setup=true&lang=js"

import "./MFAChoice.vue?vue&type=style&index=0&id=18007980&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./MFAChoice.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18007980"]])

export default __exports__